const CloseMedium = ({
  width = '19px',
  height = '19px'
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 19 19">
      <g fill="none" fillRule="evenodd">
        <g fill="#757575">
            <g>
                <path d="M15.958 2.015l.48.481-6.73 6.73 6.73 6.732-.48.48-6.732-6.73-6.73 6.73-.48-.48 6.73-6.732-6.73-6.73.48-.48 6.73 6.73 6.732-6.73z" transform="translate(-949 -111) translate(949.5 111.5)"/>
            </g>
        </g>
      </g>
    </svg>
  );
};
  
export default CloseMedium;
  